const API_URL = process.env.REACT_APP_API_URL;
const USER_SIGNIN = '/user/signinAdm';
const USER_INFO = '/user';
const USER_LOGGED = '\u00A1Bienvenid@ a Gold Admin!';
const USER_SESSION_EXPIRED = 'Sesión caducada, por favor inicia sesión otra vez.';
const USER_WITHOUT_PERMISSION = 'No tienes permisos para realizar esta acción.';
const GET_CATEGORIES = '/categories';
const GET_PRODUCTS_BY_CATEGORY = '/productsByCategory';
const GET_PRODUCT_BY_ID = '/product';
const CREATE_PRODUCT = '/product';
const PRODUCT_CREATED = '\u00A1Servicio creado exitosamente!';
const PRODUCT_UPDATED = '\u00A1Servicio actualizado exitosamente!';
const PRODUCT_DELETED = '\u00A1Servicio eliminado exitosamente!';
const PRODUCT_RESTORED = '\u00A1Servicio restaurado exitosamente!';
const PRODUCT_HAS_ACTIVE_ACCOUNTS = 'No se puede eliminar el servicio porque tiene cuentas activas.';
const PRODUCT_HAS_MOVEMENTS = 'El servicio tiene movimientos históricos.';
const GET_ALL_PRODUCTS = '/products';
const GET_ALL_RECHARGES = '/rechargeMovements';
const GET_THE_RECHARGER = '/getTheRecharger';
const GET_PRODUCTS = '/getProducts';
const GET_ACCOUNTS = '/getAccountsPage';
const GET_PENDING_DELIVERY_NEEDS = '/pendingDeliveryNeeds';
const GET_NOTIFICATIONS = '/notifications';
const PUSH_NOTIFICATIONS = '/notifications/push';
const RECHARGE_SETTINGS = '/admin/recharge-settings';
const BREB_INGESTIONS = '/admin/breb/ingestions';
const COMMERCIAL_USER_ROLE = '/admin/users/commercial-role';
const COMMERCIAL_USERS = '/admin/users/commercial';
const COMMERCIAL_USER_PASSWORD = '/admin/users/commercial-password';
const CREDENTIAL_TEMPLATE = '/user/distributor-template';
const PROFITABILITY = '/admin/profitability';
const PROFITABILITY_PROFILE_COST = '/admin/profitability/profile-cost';
const PROFITABILITY_COSTS = '/admin/profitability/costs';
const PROFITABILITY_PROFILE_COSTS = '/admin/profitability/profile-costs';
const GET_MOVEMENTS = '/movements';
const CREATE_ACCOUNT = '/createAccount';
const UPDATE_ACCOUNT = '/updateAccount';
const UPLOAD_IMAGE = '/uploadImage';
const ACCOUNT_CREATED = '\u00A1Cuenta creada exitosamente!';
const UPDATED_ACCOUNT = '\u00A1Cuenta actualizada exitosamente!';
const ACCOUNT_STATUS = { true: 'Activo', false: 'Inactivo' };
const CATEGORY_STATUS = { ...ACCOUNT_STATUS };
const QUERY_PRODUCTS = '/queryProducts';
const MODAL_TITLE_SUCCCESS = '\u00A1Se ha realizado con \u00E9xito!';
const MODAL_TITLE_ERROR = '\u00A1Oops, error en la solicitud!';
const MODAL_TITLE_SIGNOUT = 'Desconexión exitosa.';
const MODAL_BODY_SIGNOUT = 'Hasta luego, vuelve pronto...';
const PARAMS_CATEGORY_ID = 'category_id=';
const PARAMS_PAGE = 'page=';
const PARAMS_RESPONSIBLE = 'responsible=';
const PARAMS_PRODUCT = 'product=';
const PARAMS_QUERY_PRODUCT = 'productQuery=';
const PRODUCT_STATUS_ACTIVE = 'active';
const PRODUCT_STATUS_INACTIVE = 'inactive';
const LANGUAGE_TAG = 'es-CO';
const CURRENCY_NAME = 'COP';
const WIDTH_MOBILE = 500;
const POST_RECHARGE_WALLET = '/rechargeWallet';
const USER_RECHARGE_SUCCESSFULL = '¡Recarga realizada exitosamente!';
const MAX_VISIBLE_PAGES = 5;
const USER_OPTIONS = {
    admin: { recharges: true, accounts: true, combos: true, manageCombos: false, manageRechargeSettings: false, manageCredentialTemplate: true },
    superadmin: {
        services: true,
        recharges: true,
        accounts: true,
        categories: true,
        movements: true,
        combos: true,
        manageCombos: true,
        manageRechargeSettings: true,
        brebIngestions: true,
        manageCommercialUsers: true,
        manageCredentialTemplate: true,
        profitability: true
    }
};
const CATEGORY_STATUSES = { true: 'Activa', false: 'Inactiva', undefined: 'No disponible' };
const KEY_STORAGE_BASE = 'GLDST0';
const GET_CATEGORY = '/category';
const DELETE_CATEGORY = '/category';
const GET_ACTIVE_CATEGORIES = '/categories/active'
const MODAL_CONFIRM_CREATION = "¿Estás seguro de que deseas crear esta categoría?";
const MODAL_CONFIRM_CREATE_CATEGORY = "Esta acción agregará una nueva categoría a la lista.";
const CATEGORY_UPDATED = "La categoría ha sido actualizada correctamente.";
const MODAL_TITLE_DELETE = "Eliminar categoría";
const MODAL_BODY_DELETE = "¿Estás seguro de que deseas eliminar esta categoría?";
const MODAL_TILE_DELETE_SUCCESS = "¡Categoría eliminada exitosamente!";
const CATEGORY_DELETED_SUCCESSFULLY = "La categoría ha sido eliminada correctamente.";
const CATEGORY_HAS_PRODUCTS = "No se puede eliminar la categoría porque tiene productos asociados.";
const MODAL_BODY_ERROR = "Ha ocurrido un error inesperado.";
const CATEGORY_NOT_AVAILABLE = "Categoria en estado inactivo, no disponible para su uso.";
const CATEGORY_CREATED_SUCCESSFULLY = "La categoría ha sido creada exitosamente.";

const MODAL_TITLE_DELETE_PRODUCT = "Eliminar servicio";
const MODAL_BODY_DELETE_PRODUCT = "¿Estás seguro de que deseas eliminar este servicio?";
const MODAL_BODY_DELETE_PRODUCT_WITH_MOVEMENTS = "Este servicio tiene movimientos históricos. ¿Deseas eliminarlo de todas formas?";

const MODAL_TITLE_RESTORE_PRODUCT = "Restaurar servicio";
const MODAL_BODY_RESTORE_PRODUCT = "¿Estás seguro de que deseas restaurar este servicio?";

// ---------------------------------------------------------------------------
// Combos (Sprint Combos 1.0B)
// ---------------------------------------------------------------------------
const COMBO_BASE = '/combo';
const GET_COMBOS = '/combos';
const GET_COMBO = COMBO_BASE;
const CREATE_COMBO = COMBO_BASE;
const ACTIVATE_COMBO = COMBO_BASE;
const DEACTIVATE_COMBO = COMBO_BASE;
const DELETE_COMBO = COMBO_BASE;
const RESTORE_COMBO = `${COMBO_BASE}/restore`;

const COMBO_NAME_MIN_LENGTH = 3;
const COMBO_NAME_MAX_LENGTH = 120;
const COMBO_DESCRIPTION_MAX_LENGTH = 1000;
const COMBO_MAX_REQUIRED_QUANTITY = 99;
const COMBO_MIN_ITEMS = 2;
const COMBO_SEARCH_MAX_LENGTH = 120;
const COMBO_PAGE_SIZES = [10, 20, 50];
const COMBO_DEFAULT_PAGE_SIZE = 20;

const COMBO_CREATED = '¡Combo creado exitosamente!';
const COMBO_UPDATED = '¡Combo actualizado exitosamente!';
const COMBO_ACTIVATED = '¡Combo activado exitosamente!';
const COMBO_DEACTIVATED = '¡Combo desactivado exitosamente!';
const COMBO_DELETED = '¡Combo eliminado exitosamente!';
const COMBO_RESTORED = '¡Combo restaurado exitosamente!';

const MODAL_CONFIRM_CREATE_COMBO_TITLE = 'Confirmar creación';
const MODAL_CONFIRM_CREATE_COMBO_BODY = 'El combo se guardará inicialmente como inactivo.';
const MODAL_CONFIRM_UPDATE_COMBO_TITLE = 'Confirmar actualización';
const MODAL_CONFIRM_UPDATE_COMBO_BODY = 'Se guardarán los cambios realizados en el combo.';
const MODAL_TITLE_ACTIVATE_COMBO = 'Activar combo';
const MODAL_BODY_ACTIVATE_COMBO = '¿Estás seguro de que deseas activar este combo?';
const MODAL_TITLE_DEACTIVATE_COMBO = 'Desactivar combo';
const MODAL_BODY_DEACTIVATE_COMBO = '¿Estás seguro de que deseas desactivar este combo? Los servicios no se verán afectados.';
const MODAL_TITLE_DELETE_COMBO = 'Eliminar combo';
const MODAL_BODY_DELETE_COMBO = '¿Estás seguro de que deseas eliminar este combo?';
const MODAL_TITLE_RESTORE_COMBO = 'Restaurar combo';
const MODAL_BODY_RESTORE_COMBO = '¿Estás seguro de que deseas restaurar este combo? Quedará inactivo hasta que lo actives.';

const COMBO_READONLY_BADGE = 'Vista de consulta';

// Translates backend blockedReasons codes into clear messages for admins.
const COMBO_BLOCKED_REASON_MESSAGES = {
    COMBO_INACTIVE: 'El combo está inactivo.',
    COMBO_DELETED: 'El combo fue eliminado.',
    COMBO_WITHOUT_ITEMS: 'El combo no tiene servicios asociados.',
    COMBO_SERVICE_NOT_FOUND: 'Uno de los servicios del combo ya no existe.',
    COMBO_SERVICE_INACTIVE: 'Uno de los servicios del combo está inactivo.',
    COMBO_SERVICE_DELETED: 'Uno de los servicios del combo fue eliminado.',
    COMBO_SERVICE_NOT_PROFILE_BASED: 'Uno de los servicios del combo ahora se vende como cuenta completa.',
    COMBO_WITHOUT_INVENTORY: 'No hay perfiles disponibles para completar el combo.',
    COMBO_INVALID_PRICE: 'El precio especial ya no representa un ahorro real.'
};
const COMBO_BLOCKED_REASON_FALLBACK = 'El combo no está disponible por una condición no reconocida.';

export const constants = Object.freeze({
    API_URL,
    USER_SIGNIN,
    USER_INFO,
    USER_LOGGED,
    USER_SESSION_EXPIRED,
    USER_WITHOUT_PERMISSION,
    GET_CATEGORIES,
    GET_PRODUCTS_BY_CATEGORY,
    GET_PRODUCT_BY_ID,
    CREATE_PRODUCT,
    PRODUCT_CREATED,
    PRODUCT_UPDATED,
    PRODUCT_DELETED,
    PRODUCT_RESTORED,
    PRODUCT_HAS_ACTIVE_ACCOUNTS,
    PRODUCT_HAS_MOVEMENTS,
    GET_ALL_PRODUCTS,
    GET_ALL_RECHARGES,
    GET_THE_RECHARGER,
    GET_PRODUCTS,
    GET_ACCOUNTS,
    GET_PENDING_DELIVERY_NEEDS,
    GET_NOTIFICATIONS,
    PUSH_NOTIFICATIONS,
    RECHARGE_SETTINGS,
    BREB_INGESTIONS,
    COMMERCIAL_USER_ROLE,
    COMMERCIAL_USERS,
    COMMERCIAL_USER_PASSWORD,
    CREDENTIAL_TEMPLATE,
    PROFITABILITY,
    PROFITABILITY_PROFILE_COST,
    PROFITABILITY_COSTS,
    PROFITABILITY_PROFILE_COSTS,
    GET_MOVEMENTS,
    CREATE_ACCOUNT,
    UPDATE_ACCOUNT,
    ACCOUNT_CREATED,
    UPDATED_ACCOUNT,
    ACCOUNT_STATUS,
    CATEGORY_STATUS,
    UPLOAD_IMAGE,
    QUERY_PRODUCTS,
    MODAL_TITLE_SUCCCESS,
    MODAL_TITLE_ERROR,
    MODAL_TITLE_SIGNOUT,
    MODAL_BODY_SIGNOUT,
    PARAMS_CATEGORY_ID,
    PARAMS_PAGE,
    PARAMS_RESPONSIBLE,
    PARAMS_PRODUCT,
    PARAMS_QUERY_PRODUCT,
    PRODUCT_STATUS_ACTIVE,
    PRODUCT_STATUS_INACTIVE,
    LANGUAGE_TAG,
    CURRENCY_NAME,
    WIDTH_MOBILE,
    POST_RECHARGE_WALLET,
    USER_RECHARGE_SUCCESSFULL,
    MAX_VISIBLE_PAGES,
    USER_OPTIONS,
    KEY_STORAGE_BASE,
    MODAL_CONFIRM_CREATION,
    MODAL_CONFIRM_CREATE_CATEGORY,
    CATEGORY_UPDATED,
    MODAL_TITLE_DELETE,
    MODAL_BODY_DELETE,
    MODAL_TILE_DELETE_SUCCESS,
    CATEGORY_DELETED_SUCCESSFULLY,
    CATEGORY_HAS_PRODUCTS,
    MODAL_BODY_ERROR,
    GET_CATEGORY,
    DELETE_CATEGORY,
    GET_ACTIVE_CATEGORIES,
    CATEGORY_NOT_AVAILABLE,
    CATEGORY_CREATED_SUCCESSFULLY,
    CATEGORY_STATUSES,
    MODAL_TITLE_DELETE_PRODUCT,
    MODAL_BODY_DELETE_PRODUCT,
    MODAL_BODY_DELETE_PRODUCT_WITH_MOVEMENTS,
    MODAL_TITLE_RESTORE_PRODUCT,
    MODAL_BODY_RESTORE_PRODUCT,
    GET_COMBOS,
    GET_COMBO,
    CREATE_COMBO,
    ACTIVATE_COMBO,
    DEACTIVATE_COMBO,
    DELETE_COMBO,
    RESTORE_COMBO,
    COMBO_NAME_MIN_LENGTH,
    COMBO_NAME_MAX_LENGTH,
    COMBO_DESCRIPTION_MAX_LENGTH,
    COMBO_MAX_REQUIRED_QUANTITY,
    COMBO_MIN_ITEMS,
    COMBO_SEARCH_MAX_LENGTH,
    COMBO_PAGE_SIZES,
    COMBO_DEFAULT_PAGE_SIZE,
    COMBO_CREATED,
    COMBO_UPDATED,
    COMBO_ACTIVATED,
    COMBO_DEACTIVATED,
    COMBO_DELETED,
    COMBO_RESTORED,
    MODAL_CONFIRM_CREATE_COMBO_TITLE,
    MODAL_CONFIRM_CREATE_COMBO_BODY,
    MODAL_CONFIRM_UPDATE_COMBO_TITLE,
    MODAL_CONFIRM_UPDATE_COMBO_BODY,
    MODAL_TITLE_ACTIVATE_COMBO,
    MODAL_BODY_ACTIVATE_COMBO,
    MODAL_TITLE_DEACTIVATE_COMBO,
    MODAL_BODY_DEACTIVATE_COMBO,
    MODAL_TITLE_DELETE_COMBO,
    MODAL_BODY_DELETE_COMBO,
    MODAL_TITLE_RESTORE_COMBO,
    MODAL_BODY_RESTORE_COMBO,
    COMBO_READONLY_BADGE,
    COMBO_BLOCKED_REASON_MESSAGES,
    COMBO_BLOCKED_REASON_FALLBACK
});
